import { serializeURLSearchParamsStably } from './serializeURLSearchParamsStably';

export const buildListingsURL = (
  pathname: string,
  params: URLSearchParams,
  hash?: string,
): string => {
  const query = serializeURLSearchParamsStably(params);
  const normalizedHash = hash ?? '';
  return query ? `${pathname}?${query}${normalizedHash}` : `${pathname}${normalizedHash}`;
};
